import './Hero.scss'
import React from 'react'

import heroName from '../../assets/bengibert4.webp'
import Button from '../Button/Button'

function Hero() {
    const openCalendly = () => {
        if (window.Calendly) {
            window.Calendly.initPopupWidget({
                url: 'https://calendly.com/contact-benjamingibert',
            })
        }
    }

    return (
        <section className="hero" aria-labelledby="hero-title">
            <div className="hero__container">
                <div className="hero__content">
                    <img
                        src={heroName}
                        alt=""
                        className="hero__title--img"
                        aria-hidden="true"
                    />

                    <h1 id="hero-title" className="hero__subtitle">
                        Développeur & architecte technique web
                    </h1>

                    <p className="hero__tagline">
                        Votre site vitrine,{' '}
                        <em>relié à votre ERP.</em>
                    </p>

                    <p className="hero__intro">
                        Je vous aide à faire les bons choix techniques avant de
                        coder : diagnostic de l’existant, architecture sur
                        mesure, intégration entre vos outils. Je conçois aussi
                        des ERP sur mesure, connectés à votre site vitrine ou à
                        votre boutique, pour que vos commandes, vos stocks et
                        vos clients circulent sans ressaisie.
                    </p>

                    <div className="hero__actions">
                        <Button
                            variant="accentButton"
                            onClick={openCalendly}
                            type="button"
                            ariaLabel="Discuter de votre projet avec Benjamin Gibert via Calendly"
                        >
                            Discuter de votre projet
                        </Button>

                        <Button
                            type="link"
                            variant="outlineButton"
                            href="#realisations"
                        >
                            Voir les réalisations
                        </Button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Hero
